function CadreMandat({ nom, role, linkedln, mail, photo }) {
    const mailto = "mailto:" + mail;
    return (
        <div className="flex flex-col items-center md:items-start rounded-xl w-full max-w-[250px] px-2">
            <div className="flex flex-wrap justify-center md:justify-start gap-1 mb-2 max-w-full font-[Comme] font-semibold text-[12px] leading-[14px]">
                <p className="text-bleu-je truncate max-w-full text-center md:text-left">{nom}</p>
                <p className="text-gray-400 truncate max-w-full text-center md:text-left">/ {role}</p>
            </div>
            <div className="mb-2 flex flex-col items-center md:items-start w-full max-w-full">
                <img src={photo} alt="Contact" className="object-cover w-[200px]"/>
                <div className="flex justify-center md:justify-start mt-2 w-full gap-2">
                    <a href={mailto} className="inline-block">
                        <img src="images/mail.svg" alt="Mail du contact" className="w-[21px] h-[16px]"/>
                    </a>
                    <a href={linkedln} target="_blank" rel="noreferrer" className="inline-block">
                        <img src="images/logo_LinkedIn_mini.svg" alt="LinkedIn du contact" className="w-[21px] h-[16px]"/>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default CadreMandat;